<template>
  <section v-loading="loading" id="add-new-lab" class="case-creation">
    <div class="container-sm">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__body pb-0">
            <el-form :model="labData" class="vue-form">
              <el-row :gutter="20">
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Lab Name
                        <span class="star">*</span>
                      </label>

                      <el-input
                        placeholder="Enter Name"
                        v-model="labData.name"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="name"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Lab Code
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Code"
                        v-model="labData.lab_code"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="lab_code"></FormError>
                      </p>

                      <p class="err">
                        <FormError errorName="critical_error"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Phone Number
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Phone Number"
                        v-model="labData.phone"
                        maxlength="10"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="phone"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Fax </label>
                      <el-input
                        placeholder="Enter Fax"
                        v-model="labData.fax"
                        maxlength="10"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="fax"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">Email</label>
                      <el-input
                        class="email-lower"
                        type="email"
                        placeholder="Enter Email"
                        v-model="labData.email"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="email"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="7" :lg="7" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Address Line 1
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Address Line 1"
                        v-model="labData.address_line_1"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="address_line_1"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="7" :lg="7" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">Address Line 2</label>
                      <el-input
                        placeholder="Enter Address Line 2"
                        v-model="labData.address_line_2"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="address_line_2"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Zip </label>
                      <el-input maxlength="5" v-model="labData.zip"></el-input>
                      <p class="err">
                        <FormError errorName="zip"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <state :stateData="labData"> </state>
                      <p class="err">
                        <FormError errorName="state"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <city :cityData="labData"></city>
                      <p class="err">
                        <FormError errorName="city"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> County </label>
                      <el-input v-model="labData.country"></el-input>
                      <p class="err">
                        <FormError errorName="country"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">Director</label>
                      <el-input v-model="labData.director"></el-input>
                      <p class="err">
                        <FormError errorName="director"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="7" :lg="7" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">Website</label>
                      <el-input v-model="labData.website"></el-input>
                      <p class="err">
                        <FormError errorName="website"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">CLIA Id</label>
                      <el-input v-model="labData.clia_id"></el-input>
                      <p class="err">
                        <FormError errorName="clia_id"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Accession Letter
                        <span class="star">*</span>
                      </label>
                      <el-input
                        v-model="labData.accession_letter"
                        placeholder="Enter Accession Letter"
                        class="el-input convert-upper"
                        maxlength="1"
                        type="text"
                      >
                      </el-input>
                      <p class="err">
                        <FormError errorName="accession_letter"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="5" :lg="5" :md="8" :sm="8" :xs="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Timezone
                        <span class="star">*</span>
                      </label>
                      <el-select
                        v-model="labData.timezone"
                        placeholder="Select"
                        filterable
                      >
                        <el-option
                          v-for="item in getAllTimeZones"
                          :key="item.name"
                          :label="item.name"
                          :value="item.name"
                        >
                        </el-option>
                      </el-select>
                      <p class="err">
                        <FormError errorName="timezone"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :span="24">
                  <p class="err">
                    <FormError errorName="critical_error"></FormError>
                  </p>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="case-creation__actions">
          <ul class="list">
            <li>
              <el-button
                type="default"
                class="btn cancel-button"
                @click="cancelLabDetails"
                >Cancel</el-button
              >
            </li>
            <li>
              <el-button
                type="success"
                class="btn save-button"
                @click="submitLabDetails"
                :loading="loading"
              >
                Save
              </el-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      labData: {
        city: "",
        state: "",
      },
    };
  },
  components: {
    state,
    city,
    FormError,
  },
  computed: {
    ...mapGetters("labs", [
      "getLabAddStatus",
      "getAddedlabData",
      "getSingleLab",
      "getAllTimeZones",
    ]),
    ...mapGetters("help", ["getAllStates"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
  },
  mounted() {
    this.$store.dispatch("errors/clear");
    this.$store.dispatch("help/fetchAllStates");
    this.$store.dispatch("labs/fetchAllTimeZones");
    if (this.$route.params.lab_id) {
      this.getLabDetails();
    }
  },
  methods: {
    convertToLower(value) {
      if (value) {
        this.patientInformationFormData.email = value.toLowerCase();
      }
    },

    goToLabs() {
      this.$router.push({
        path: "/labs",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    parseLabInfo(labInfo) {
      let params = { ...labInfo };
      if (!params.zip) delete params.zip;
      if (!params.country) delete params.country;
      if (!params.fax) delete params.fax;
      if (!params.director) delete params.director;
      if (!params.address_line_2) delete params.address_line_2;
      if (!params.email) delete params.email;
      if (!params.website) delete params.website;
      if (!params.clia_id) delete params.clia_id;
      if (params.email) {
        params.email = params.email.toLowerCase();
      }
      if(params.accession_letter){
        params.accession_letter = params.accession_letter.toUpperCase()
      }
      return params;
    },
    async submitLabDetails() {
      this.loading = true;
      let params = this.parseLabInfo(this.labData);
      if (this.$route.params.lab_id) {
        params.id = this.$route.params.lab_id;
        this.labData.address_line2 = this.labData.address_line_2
          ? this.labData.address_line_2
          : undefined;
        await this.$store.dispatch("labs/editLab", params);
      } else {
        await this.$store.dispatch("labs/addLab", params);
      }

      if (this.getLabAddStatus) {
        successNotification(
          this.$route.params.lab_id
            ? "Lab Data Updated Successfully"
            : "New Lab Created Successfully"
        );

        this.goToLabs();
      } else if (!this.getErrors) {
        errorNotification(this.getError);
      }

      this.loading = false;
    },
    async getLabDetails() {
      this.loading = true;
      await this.$store.dispatch(
        "labs/fetchSingleLab",
        this.$route.params.lab_id
      );
      this.labData = this.getSingleLab;
      this.loading = false;
    },
    cancelLabDetails() {
      if (Object.keys(this.labData).length === 0 || this.$route.params.lab_id) {
        this.goToLabs();
      } else {
        this.$confirm("Are you sure to cancel adding new Lab?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          this.goToLabs();
        });
      }
    },
  },
};
</script>
<style lang="scss"></style>
